import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import RichTextA11yWrapper from 'components/helpers/RichTextA11yWrapper';
import { getEnumValue } from 'lib/util/enum';
import AlertPrimary from 'components/helpers/SvgIcon/icons/alert-primary';
import AlertSuccess from 'components/helpers/SvgIcon/icons/alert-success';
import AlertDanger from 'components/helpers/SvgIcon/icons/alert-danger';
import AlertWarning from 'components/helpers/SvgIcon/icons/alert-warning';

export type AlertBannerProps = Sitecore.Override.ComponentBase &
  Components.General.AlertBanner.Fields.AlertBanner;

const AlertBanner = ({ fields }: AlertBannerProps) => {
  if (!fields) {
    return <MissingDataSource />;
  }
  const isImage = fields.isAlertImage?.value;
  const typeOfAlert = getEnumValue(fields.alertType);

  const alertType = classnames(
    'rounded',
    'mb-4',
    'py-4',
    'px-6',
    'flex',
    'text-black',
    'leading-4',
    'lg:mb-6',
    {
      'bg-blue-night-tint': typeOfAlert === 'Primary',
      'bg-success bg-opacity-[15%]': typeOfAlert === 'Success',
      'bg-red-destructive bg-opacity-[15%]': typeOfAlert === 'Danger',
      'bg-warning bg-opacity-[25%]': typeOfAlert === 'Warning',
    }
  );

  let alertIcon;

  switch (typeOfAlert) {
    case 'Primary':
      alertIcon = <AlertPrimary />;
      break;
    case 'Success':
      alertIcon = <AlertSuccess />;
      break;
    case 'Danger':
      alertIcon = <AlertDanger />;
      break;
    case 'Warning':
      alertIcon = <AlertWarning />;
      break;
    default:
      alertIcon = null;
  }

  return (
    <div data-component="authorable/general/alertbanner" className={alertType}>
      {isImage && <span className={classnames('pr-2')}>{alertIcon}</span>}
      <RichTextA11yWrapper field={fields.alertText} />
    </div>
  );
};

export default AlertBanner;
